var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-3);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9103",
    "data-name": "Path 9103",
    d: "M10.016,0a10.766,10.766,0,0,1,9.972,6.461.556.556,0,0,1-1.025.432,9.654,9.654,0,0,0-8.947-5.78,9.654,9.654,0,0,0-8.947,5.78A.556.556,0,0,1,.044,6.461,10.766,10.766,0,0,1,10.016,0Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9105",
    "data-name": "Path 9105",
    d: "M19.406,0a.556.556,0,0,1,.582.768,10.766,10.766,0,0,1-9.972,6.461A10.766,10.766,0,0,1,.044.773.556.556,0,1,1,1.069.34a9.654,9.654,0,0,0,8.947,5.78A9.654,9.654,0,0,0,18.962.34.556.556,0,0,1,19.406,0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9107",
    "data-name": "Path 9107",
    d: "M5.842.522a3.895,3.895,0,1,1-3.895,0A3.895,3.895,0,0,1,5.842.522ZM1.457,2.494A2.782,2.782,0,1,0,3.994,1.116l-.1,0H3.788A2.782,2.782,0,0,0,1.457,2.494Z",
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19275",
    "data-name": "Group 19275",
    transform: "translate(0 0.307)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18725",
    "data-name": "Rectangle 18725",
    className: "cls-1",
    width: 25,
    height: 17,
    transform: "translate(0 -0.306)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19273",
    "data-name": "Group 19273",
    transform: "translate(2.504 1.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19268",
    "data-name": "Group 19268",
    className: "cls-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9102",
    "data-name": "Path 9102",
    d: "M0,0H20.031V7.234H0Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19270",
    "data-name": "Group 19270",
    transform: "translate(0 6.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19269",
    "data-name": "Group 19269",
    className: "cls-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9104",
    "data-name": "Path 9104",
    d: "M0,0H20.031V7.234H0Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19272",
    "data-name": "Group 19272",
    transform: "translate(6.121 2.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19271",
    "data-name": "Group 19271",
    className: "cls-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9106",
    "data-name": "Path 9106",
    d: "M0,0H7.79V7.79H0Z",
    transform: "translate(0 0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.e2990db6972a6cc6fe5d16575ef6af67.svg";
export { ForwardRef as ReactComponent };